import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function useSearchParams<T extends Record<string, any>>(): Partial<T> {
	const { search } = useLocation();
	return useMemo(() => {
		const params = new URLSearchParams(search);
		const result: any = {};
		for (const [key, value] of params.entries()) {
			result[key] = value;
		}
		return result as Partial<T>;
	}, [search]);
}

